import * as React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { useLanguage } from '../../../services/localization/LanguageContex'; // adjust path as needed


export default function BasicBreadcrumbs() {
  const { t } = useLanguage();
  const location = useLocation();
  let currentLink = '';

  const pathnames = location.pathname
    .split('/')
    .filter((x) => x);

  const crumbs = pathnames.map((crumb, index) => {
    currentLink += `/${crumb}`;
    const isLast = index === pathnames.length - 1;
    // const label = decodeURIComponent(crumb.charAt(0).toUpperCase() + crumb.slice(1));
    // console.log("first",crumb.charAt(0).toUpperCase())
    // console.log("last",crumb.slice(1));
    // const label = t(decodeURIComponent(t(crumb.charAt(0).toUpperCase()) + t(crumb.slice(1))));
    const label= t(decodeURIComponent(crumb));
    // console.log(crumb);

    return isLast ? (
      <Typography key={index} sx={{ color: 'text.primary' }}>
        {label}
      </Typography>
    ) : (
      <Link
        key={index}
        underline="hover"
        color="inherit"
        component={RouterLink}
        to={currentLink}
      >
        {label}
      </Link>
    );
  });

  return (
    <Box 
      sx={{
        display: "flex", 
        justifyContent: "center",

        marginTop: '64px',
        pt: 3,
        // pl:6,
        // pr:6
        px: { xs: 3, sm: 6, md: 6 },
  
      }}
    >
      <Breadcrumbs aria-label="breadcrumb">
        {crumbs}
      </Breadcrumbs>   
    </Box>
  );
}




// export default function BasicBreadcrumbs({ links = [] }) {
//   const [autoLinks, setAutoLinks] = React.useState([]);

//   React.useEffect(() => {
//     if (links.length === 0) {
//       // Auto-generate from URL
//       const pathnames = window.location.pathname.split('/').filter(x => x);
//       const generatedLinks = pathnames.map((value, index) => {
//         const href = '/' + pathnames.slice(0, index + 1).join('/');
//         return {
//           label: decodeURIComponent(value.charAt(0).toUpperCase() + value.slice(1)), // Capitalize
//           href: href
//         };
//       });
//       setAutoLinks(generatedLinks);
//     }
//   }, []);

//   const breadcrumbs = links.length > 0 ? links : autoLinks;

//   return (
//     <Box 
//       sx={{
//         display: "flex", 
//         justifyContent: "center",
//         marginTop: '64px',
//         pt: 3
//       }}
//     >
//       <Breadcrumbs aria-label="breadcrumb">

//         {/* Dynamically Generated Links */}
//         {breadcrumbs.map((item, index) => {
//           const isLast = index === breadcrumbs.length - 1;
//           return isLast ? (
//             <Typography key={index} sx={{ color: 'text.primary' }}>
//               {item.label}
//             </Typography>
//           ) : (
//             <Link 
//               key={index} 
//               underline="hover" 
//               color="inherit" 
//               href={item.href}
//             >
//               {item.label}
//             </Link>
//           );
//         })}
//       </Breadcrumbs>   
//     </Box>
//   );
// }
